import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {PipelineFlow, PipelineFlowEntity} from "../../../model/pipeline/pipeline-flow";

export interface PipelineFlowSelectorProps {
  regionId?: string
}

const getRegionIdParam = createParamSelector<PipelineFlowSelectorProps | undefined, string | undefined>(params => params?.regionId);

export const pipelineFlowsSelector = () => createSelector(
  [getUseQueryResultData<PipelineFlow[]>, getRegionIdParam],
  (data, regionId) => {
    return selectPipelineFlowsAndTransform(
      data ?? [], {
        regionId: regionId,
      }
    );
  }
);

export const pipelineFlowSelector = () => createSelector(
  [getUseQueryResultData<PipelineFlow>],
  (data) => {
    return data ? transformPipelineFlow(data) : undefined;
  }
);

export const selectPipelineFlows = (values?: PipelineFlow[], selector?: PipelineFlowSelectorProps): PipelineFlow[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (v.regionId !== selector.regionId) {
        filterIn = false;
      }
    }

    return filterIn;
  });
};

export const transformPipelineFlow = (value: PipelineFlow): PipelineFlowEntity => {
  return PipelineFlowEntity.from(value)
}

export const selectPipelineFlowsAndTransform = (values?: PipelineFlow[], selector?: PipelineFlowSelectorProps): PipelineFlowEntity[] => {
  const selected = selectPipelineFlows(values, selector);
  return selected.map(transformPipelineFlow);
};
